import { createContext, useContext } from 'react';
import { IAudienceManagerListViewConfig } from '~/src/dash/views/segments/audience/AudienceManagerSettingsListView/config';

interface IAudienceManagerListContext {
  cfg: IAudienceManagerListViewConfig;
}

export const AudienceManagerListContext = createContext({} as IAudienceManagerListContext);
export const useAudienceManagerListStore = (): IAudienceManagerListContext =>
  useContext(AudienceManagerListContext);
